// 9fbef606107a605d69c0edbcd8029e5d 
export default {
  WALLET_FOOTER_LINKS: 'wallet-footer-links',
};
